import React, { useState, useRef, useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import FlipCards from './pages/flashcards/FlipCards'
import Quiz from './pages/quiz/Quiz'
// import Switchy from "./Switchy";
import SideMenu from './components/SideMenu'
import ModoInverso from './pages/dragdrop/ModoInverso'
import useDarkMode from './hooks/useDarkMode'
import Header from './components/Header'
import MenuPrincipal from './components/MenuPrincipal'
import GlobalReview from './pages/flashcards/GlobalReview'
import Search from './pages/Search'

function App() {
  const [menuVisible, setMenuVisible] = useState(false)
  const [vocabFile, setVocabFile] = useState('vocabulario.json')
  const [isDarkMode, setDarkMode] = useDarkMode()

  const menuRef = useRef(null)
  const switchRef = useRef(null)

  const handleToggleMenu = () => {
    setMenuVisible((v) => !v)
  }

  const handleCloseMenu = () => {
    setMenuVisible(false)
  }

  useEffect(() => {
    document.body.classList.toggle('dark-mode', isDarkMode)
  }, [isDarkMode])

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        menuVisible &&
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        switchRef.current &&
        !switchRef.current.contains(event.target)
      ) {
        setMenuVisible(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [menuVisible])

  return (
    <Router>
      <div className={`app-container${isDarkMode ? ' dark' : ''}`}>
        {/* Cabecera fija */}
        <Header
          switchRef={switchRef}
          menuVisible={menuVisible}
          handleToggleMenu={handleToggleMenu}
          darkMode={isDarkMode}
        />
        {/* SideMenu */}
        {menuVisible && (
          <div ref={menuRef}>
            <SideMenu
              onOptionClick={handleCloseMenu}
              darkMode={isDarkMode}
              setDarkMode={setDarkMode}
              vocabFile={vocabFile}
            />
          </div>
        )}

        <div
          className='main-content'
          style={{
            marginLeft: menuVisible ? '220px' : '0',
            padding: '20px',
            width: '100%',
            transition: 'margin-left 0.3s'
          }}
        >
          <Routes>
            <Route
              path='/'
              element={
                // <div>
                //   <h1 style={{}}>Bienvenido a Japonés Quiz</h1>
                <MenuPrincipal
                  onOptionClick={handleCloseMenu}
                  darkMode={isDarkMode}
                  vocabFile={vocabFile}
                  setVocabFile={setVocabFile}
                />
                // </div>
              }
            />
            <Route
              path='/flipcards/:category'
              element={<FlipCards vocabFile={vocabFile} darkMode={isDarkMode} />}
            />
            <Route path='/quiz-particulas' element={<Quiz />} />
            <Route path='/drag-drop' element={<ModoInverso />} />
            <Route
              path='/global-review'
              element={
                <GlobalReview
                  vocabFile={vocabFile}
                  setVocabFile={setVocabFile}
                  darkMode={isDarkMode}
                />
              }
            />
            <Route path='/buscar' element={<Search />} />
          </Routes>
        </div>

        {/* Footer global */}
        {/* <footer className='global-footer'>
          <span>© {new Date().getFullYear()} Japonés Quiz</span>
        </footer> */}
      </div>
    </Router>
  )
}

export default App
